import api from ".";
import { toast } from "react-toastify";
import { handleApiError } from "../utils/toastUtil";

export const login = async (email, password, toast, navigate, setUser, t) => {
  try {
    const response = await api.post("/auth/login", { email, password });

    if (response.data.result) {
      navigate('/otp')
    }
  } catch (error) {
    const status = error.response?.status;

    if (status === 403) {
      handleApiError(error.response.data);
    } else if (status === 404) {
      handleApiError("toast.auth.errors.user_not_found");
    } else {
      handleApiError(
        error.response?.data?.message || "toast.auth.errors.general_error"
      );
    }
  }
};

export const confirmLogin = async (otp, toast, navigate, setUser, t) => {
  try {
    const response = await api.post("/auth/confirm-login", { otp });

    const user = response.data.user;
    const role = user.role === "reception" ? "receptionist" : user.role;

    localStorage.setItem("user", JSON.stringify(user));
    setUser(user);
    sessionStorage.setItem(
      "invoiceDateRange",
      JSON.stringify({
        startDate: new Date().toISOString().split("T")[0],
        endDate: new Date().toISOString().split("T")[0],
      })
    );

    navigate(`/${role}`);
  } catch (error) {
    const status = error.response?.status;

    if (status === 403) {
      toast.error("OTP is invalid or expired!")
    } else if (status === 404) {
      handleApiError("toast.auth.errors.user_not_found");
    } else {
      handleApiError(
        error.response?.data?.message || "toast.auth.errors.general_error"
      );
    }
  }
};

export const logout = async (navigate, toast, setUser, t) => {
  try {
    await api.post("/auth/logout");
    setUser(null);
    localStorage.removeItem("user");
    navigate("/");
  } catch (error) {
    console.error(error.response?.data?.message);
  }
};

export const authorization = async () => {
  try {
    const response = await api.get("/auth/authorize", {
      withCredentials: true,
    });
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const createUser = async (userData, toast, t) => {
  try {
    const response = await api.post("/auth/user", userData);
    toast.success(t("toast.auth.success.user_created"));
    return response.data;
  } catch (error) {
    if (error.status === 409) {
      handleApiError("toast.auth.errors.email_already_used");
    } else {
      handleApiError(
        error.response?.data?.message || "toast.auth.errors.user_create_failed"
      );
    }
    return false;
  }
};

export const findAllUsers = async (toast, t) => {
  try {
    const response = await api.get("/auth/users");
    return response.data;
  } catch (error) {
    handleApiError("toast.auth.errors.user_fetch_failed");
  }
};

export const findUsersByRole = async (role, toast, t) => {
  try {
    const response = await api.get(`/auth/filter-by-role/${role}`);
    return response.data;
  } catch (error) {
    handleApiError("toast.auth.errors.user_fetch_by_role_failed");
  }
};

export const updateUser = async (userId, userData, toast, setUser, t) => {
  try {
    const response = await api.patch(`/auth/user/${userId}`, userData);
    setUser(response.data);
    return response;
  } catch (error) {
    if (error.status === 409) {
      console.log("hii");
      handleApiError("toast.auth.errors.email_already_used");
    } else {
      handleApiError("toast.auth.errors.user_update_failed");
    }
  }
};

export const updateOtherUser = async (userId, userData, toast, t) => {
  try {
    const response = await api.patch(`/auth/user/${userId}`, userData);
    if (response.status === 200) {
      toast.success(t("toast.auth.success.status_updated"));
    }
    return response;
  } catch (error) {
    if (error.status === 409) {
      handleApiError("toast.auth.errors.email_already_used");
    } else {
      handleApiError(
        error.response?.data?.message || "toast.auth.errors.user_update_failed"
      );
    }
    return false;
  }
};

export const changeUserPassword = async (
  oldPassword,
  newPassword,
  confirmNewPassword,
  toast,
  userId,
  t
) => {
  try {
    if (confirmNewPassword !== newPassword) {
      handleApiError("toast.auth.errors.password_mismatch");
      return false;
    } else if (oldPassword === newPassword) {
      handleApiError("toast.auth.errors.password_same_as_old");
      return false;
    }
    const response = await api.patch(`/auth/change-password`, {
      oldPassword,
      newPassword,
      userId,
    });
    toast.success(t("toast.auth.success.password_changed"));
    return true;
  } catch (error) {
    handleApiError(
      error.response?.data?.message ||
      "toast.auth.errors.password_change_failed"
    );
    return false;
  }
};

export const changeUserPasswordAdmin = async (
  userId,
  newPassword,
  toast,
  t
) => {
  try {
    const response = await api.patch(
      `auth/users/${userId}`,
      { newpassword: newPassword },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    toast.success(t("toast.auth.success.password_updated"));
    return response.data;
  } catch (error) {
    handleApiError(
      error.response?.data?.message ||
      "toast.auth.errors.password_update_failed"
    );
    return null;
  }
};
